
import Card from 'vux/src/components/card/index.vue'

import { go } from '../libs/misc'

export default {
  components: { Card },
  props: {
    fields: { type: Array, required: true },
    link: [String, Object]
  },
  methods: {
    onClick () {
      this.link && go(this.link, this.$router)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/HCard.vue